import React from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';

const td = {padding:'12px 10px', color:'#333', verticalAlign:'middle', fontSize:13};
const iconOrange = {fontSize:15, marginRight:10, color:'#FF6A00', verticalAlign:'middle'};

// Wrapper de hover: div que muda o fundo ao passar o mouse (funciona em desktop e mobile via touch)
class MenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hovered: false };
    }
    render() {
        const { children, style } = this.props;
        return (
            <div
                onMouseEnter={() => this.setState({ hovered: true })}
                onMouseLeave={() => this.setState({ hovered: false })}
                style={{
                    backgroundColor: this.state.hovered ? '#f5f5f5' : 'transparent',
                    transition: 'background .1s',
                    ...style,
                }}>
                {children}
            </div>
        );
    }
}

const itemInner = {
    display: 'flex', alignItems: 'center', padding: '9px 16px',
    fontSize: 13, width: '100%', textAlign: 'left', cursor: 'pointer',
    background: 'none', border: 'none', textDecoration: 'none',
};

export class Empresa extends React.Component {
    constructor(props) {
        super(props);
        this.state = { menuAberto: false, menuTop: 0, menuRight: 0 };
        this.botaoRef = React.createRef();
        this.abrirMenu = this.abrirMenu.bind(this);
        this.fecharMenu = this.fecharMenu.bind(this);
        this._fecharAoScroll = this._fecharAoScroll.bind(this);
    }

    montarLinkPainelConfiguracao(empresa) {
        return `/painel-configuracao-bpe?codigoEmpresa=${empresa.id}&habilitadaBPe=${empresa.habilitadoBpe}&pagina=empresa`
    }

    montarLinkPainelConfiguracaoBilhete(empresa) {
        return `/painel-configuracao-bilhete?codigoEmpresa=${empresa.id}&pagina=empresa`
    }

    abrirMenu() {
        const rect = this.botaoRef.current.getBoundingClientRect();
        this.setState({
            menuAberto: true,
            menuTop: rect.bottom + 4,
            menuRight: window.innerWidth - rect.right,
        });
        window.addEventListener('scroll', this._fecharAoScroll, { passive: true, capture: true });
    }

    // setTimeout: garante que Bootstrap processa data-toggle="modal" antes do menu
    // sair do DOM (necessário para modais em desktop e mobile)
    fecharMenu() {
        setTimeout(() => {
            this.setState({ menuAberto: false });
            window.removeEventListener('scroll', this._fecharAoScroll, { capture: true });
        }, 0);
    }

    _fecharAoScroll() {
        this.setState({ menuAberto: false });
        window.removeEventListener('scroll', this._fecharAoScroll, { capture: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._fecharAoScroll, { capture: true });
    }

    render() {
        const emp = this.props.empresa;
        const bloqueada = emp.bloqueada;
        const { menuAberto, menuTop, menuRight } = this.state;

        return (
            <tr style={{borderBottom:'1px solid #f4f4f4', transition:'background .12s'}}
                onMouseEnter={e => e.currentTarget.style.background='#fafafa'}
                onMouseLeave={e => e.currentTarget.style.background=''}>
                <td style={{...td, color:'#555', fontSize:12, fontFamily:'monospace', whiteSpace:'nowrap'}}>{emp.id}</td>
                <td style={td}>
                    <div style={{fontWeight:600, color:'#1a1a1a'}}>{emp.nome}</div>
                    {bloqueada && (
                        <span style={{display:'inline-block', marginTop:3, fontSize:10, fontWeight:700, color:'#c62828', background:'#fdecea', padding:'2px 7px', borderRadius:10, letterSpacing:.3}}>
                            BLOQUEADA
                        </span>
                    )}
                </td>
                <td style={td}>{emp.nomeFantasia}</td>
                <td style={{...td, color:'#555', fontSize:12, fontFamily:'monospace'}}>{emp.cnpj}</td>
                <td style={{...td, color:'#555', fontSize:12, maxWidth:200, overflowWrap:'break-word'}}>{emp.email}</td>
                <td style={{...td, color:'#888', fontSize:12, whiteSpace:'nowrap'}}>{emp.dataCriacao}</td>
                <td style={{...td, textAlign:'center', width:52}}>
                    <div style={{position:'relative'}}>
                        <button
                            ref={this.botaoRef}
                            className="btn btn-link btn-sm"
                            type="button"
                            onClick={this.abrirMenu}
                            style={{color:'#999', padding:'4px 6px', borderRadius:6, lineHeight:1}}>
                            <i className="material-icons" style={{fontSize:22}}>more_vert</i>
                        </button>

                        {menuAberto && (
                            <>
                                {/* overlay fecha ao clicar/tocar fora — funciona em mobile */}
                                <div
                                    style={{position:'fixed', top:0, left:0, right:0, bottom:0, zIndex:999}}
                                    onClick={this.fecharMenu}
                                />
                                {/* position:fixed escapa o overflow:hidden do .vx-table-card */}
                                <div style={{
                                    position: 'fixed',
                                    top: menuTop,
                                    right: menuRight,
                                    left: 'auto',
                                    zIndex: 1000,
                                    background: '#fff',
                                    minWidth: 210,
                                    borderRadius: 10,
                                    boxShadow: '0 6px 24px rgba(0,0,0,.13)',
                                    border: '1px solid #f0f0f0',
                                    padding: '6px 0',
                                }}>

                                    <MenuItem>
                                        <Link to={`/painel-empresas/editar/${emp.id}`}
                                              onClick={this.fecharMenu}
                                              style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={iconOrange}>edit</i>
                                            Editar
                                        </Link>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalImpostoEmpresa"
                                                onClick={() => { this.props.buscarImpostoEmpresa(emp.id); this.props.selecionarEmpresa(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={iconOrange}>gavel</i>
                                            Impostos
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalCieloLinkEmpresa"
                                                onClick={() => { this.props.abrirModalCieloLink(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={iconOrange}>credit_card</i>
                                            Cielo Link
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalCieloEcommerceEmpresa"
                                                onClick={() => { this.props.abrirModalCieloEcommerce(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={{...iconOrange, color:'#003087'}}>crop_free</i>
                                            Cielo E-commerce
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalSicoobEmpresa"
                                                onClick={() => { this.props.abrirModalSicoob(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={{...iconOrange, color:'#003087'}}>account_balance</i>
                                            Sicoob PIX
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalStoneConnectEmpresa"
                                                onClick={() => { this.props.abrirModalStoneConnect(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={{...iconOrange, color:'#00b140'}}>tap_and_play</i>
                                            Stone Connect
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <Link to={this.montarLinkPainelConfiguracao(emp)}
                                              onClick={() => { this.props.selecionarEmpresa(emp); this.fecharMenu(); }}
                                              style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={iconOrange}>settings</i>
                                            Config. BPe
                                        </Link>
                                    </MenuItem>

                                    <MenuItem>
                                        <Link to={this.montarLinkPainelConfiguracaoBilhete(emp)}
                                              onClick={this.fecharMenu}
                                              style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={iconOrange}>confirmation_number</i>
                                            Config. Bilhete
                                        </Link>
                                    </MenuItem>

                                    <div style={{borderTop:'1px solid #f0f0f0', margin:'4px 0'}} />

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalConfirmacaoBloqueioEmpresa"
                                                onClick={() => { this.props.selecionarEmpresa(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#333'}}>
                                            <i className="material-icons" style={{...iconOrange, color: bloqueada ? '#2e7d32' : '#e65100'}}>
                                                {bloqueada ? 'lock_open' : 'lock'}
                                            </i>
                                            {bloqueada ? 'Desbloquear' : 'Bloquear'}
                                        </button>
                                    </MenuItem>

                                    <MenuItem>
                                        <button type="button"
                                                data-toggle="modal" data-target="#modalConfirmacaoExclusaoEmpresa"
                                                onClick={() => { this.props.selecionarEmpresa(emp); this.fecharMenu(); }}
                                                style={{...itemInner, color:'#c62828'}}>
                                            <i className="material-icons" style={{fontSize:15, marginRight:10, color:'#c62828'}}>delete</i>
                                            Excluir
                                        </button>
                                    </MenuItem>
                                </div>
                            </>
                        )}
                    </div>
                </td>
            </tr>
        )
    }
}

export default connect()(Empresa)
